export default __webpack_public_path__ + "static/media/recieved-application.38f15897.svg";